
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://xeusqzvzxkuparuzbwgh.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhldXNxenZ6eGt1cGFydXpid2doIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDIzODc2NjgsImV4cCI6MjA1Nzk2MzY2OH0.NIA-2Yt89WWBai2X-15lzwQf59ewml7w3yKUt_UHmQw";

// Create a singleton Supabase client with auto-refresh capabilities
const createSupabaseClient = () => {
  const client = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true
    },
    realtime: {
      params: {
        eventsPerSecond: 10
      }
    },
    global: {
      fetch: function(...args) {
        // Add request timestamp for debugging
        console.debug(`Supabase request: ${new Date().toISOString()}`);
        return fetch.apply(window, args);
      }
    }
  });

  // Add event listeners to handle app visibility changes
  if (typeof document !== 'undefined') {
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        console.debug('App became visible, refreshing Supabase connection');
        // Refresh auth state when app becomes visible again
        client.auth.refreshSession();
      }
    });
  }

  return client;
};

// Export the Supabase client as a singleton
export const supabase = createSupabaseClient();

// Helper function to reconnect/refresh if needed
export const refreshSupabaseConnection = async () => {
  try {
    // Ping the Supabase API to verify connection
    const { error } = await supabase.from('profiles').select('id').limit(1);
    
    if (error) {
      console.error('Supabase connection error, refreshing session:', error);
      await supabase.auth.refreshSession();
    }
  } catch (err) {
    console.error('Error checking Supabase connection:', err);
  }
};
